var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5489V16.2155H7.5V14.5489H2.5ZM2.5 4.54887V6.21554H10.8333V4.54887H2.5ZM10.8333 17.8822V16.2155H17.5V14.5489H10.8333V12.8822H9.16667V17.8822H10.8333ZM5.83333 7.8822V9.54887H2.5V11.2155H5.83333V12.8822H7.5V7.8822H5.83333ZM17.5 11.2155V9.54887H9.16667V11.2155H17.5ZM12.5 7.8822H14.1667V6.21554H17.5V4.54887H14.1667V2.8822H12.5V7.8822Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.5489V16.2155H7.5V14.5489H2.5ZM2.5 4.54887V6.21554H10.8333V4.54887H2.5ZM10.8333 17.8822V16.2155H17.5V14.5489H10.8333V12.8822H9.16667V17.8822H10.8333ZM5.83333 7.8822V9.54887H2.5V11.2155H5.83333V12.8822H7.5V7.8822H5.83333ZM17.5 11.2155V9.54887H9.16667V11.2155H17.5ZM12.5 7.8822H14.1667V6.21554H17.5V4.54887H14.1667V2.8822H12.5V7.8822Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.990e1faa437737a4b144078af6a3b665.svg";
export { ForwardRef as ReactComponent };